<template>
    <div>
        <div class="home-container">
                <!-- style="height:300px;"-->
            <!-- <el-carousel :interval="5000" style="height:360px;" indicator-position="none">
            <el-carousel-item v-for="(item, index) in carousels" :key="index"  style="height:360px;">
                <el-image :src="item.itemUrl" style="height:360px;"></el-image>
            </el-carousel-item>
            </el-carousel> -->
            <div style="position:relative;">
                <!-- <img src="../assets/images/huiheidi1.png" style="width:100%;height:460px;"/> -->
            <!-- <el-carousel :interval="5000" style="height:460px;z-index: 0;" indicator-position="none">
            <el-carousel-item v-for="(item, index) in carousels" :key="index"  style="height:460px;">
                <el-image :src="item.itemUrl" style="height:460px;width: 100%;"></el-image>
            </el-carousel-item>
            </el-carousel> -->
                <img :src="carouselsImg" style="width:100%;height:460px;"/>
            <!-- 18 -->
                <div class="top-img-font">
                    <div class="font1">
                        扎根湖南本土{{year1}}年
                        
                    </div>
                    <div class="font2">
                        背靠GFKD大数据团队
                    </div>
                    <div class="font3">
                        等效分分析法 | 多维角度数据模型
                    </div>
                </div>
                <div class="top-img-font2">
                    <div class="font1">金榜志愿通</div>
                    <div class="font2">高考定成功</div>
                </div>
                <div class="top-img-font3">
                    <div class="font1">教育是海</div>
                    <div class="font2">情怀是舟</div>
                    <div class="font3">志愿是海</div>
                    <div class="font4">工具是舟</div>
                </div>
            </div>
            <!-- <div class="home-login" v-if="!token">
                <div class="login-pane">
                    <div class="login-top">
                        <span>模拟报志愿</span>
                        <span>
                            <el-select size="small" style="width:100px;" v-model="sssf"></el-select>
                        </span>
                    </div>
                    <div class="flex-div">
                        <div>首选科目</div>
                        <div style="width:188px;">
                            <el-button size="small" :type="wlType" @click="changeSxkm(2)">物理</el-button>
                            <el-button size="small" :type="lsType" @click="changeSxkm(1)">历史</el-button>
                        </div>
                    </div>
                    <div class="flex-div">
                        <div>
                            <div>再选科目</div>
                            <div style="font-size:12px;">(4选2)</div>
                        </div>
                        <div style="width:188px;">
                            <el-button size="small" :type="hxType" @click="changeZxkm('化学')">化学</el-button>
                            <el-button size="small" :type="swType" @click="changeZxkm('生物')">生物</el-button>
                            <el-button size="small" :type="zzType" @click="changeZxkm('政治')">政治</el-button>
                            <el-button size="small" style="margin-left: 0;margin-top: 10px;"
                            :type="dlType" @click="changeZxkm('地理')">地理</el-button>
                        </div>
                    </div>
                    <div class="flex-div">
                        <div>高考分数</div>
                        <div style="width:188px;">
                            <el-input size="small" style="width:120px;" v-model="score">
                                <template slot="append">分</template>
                            </el-input>
                        </div>
                    </div>
                    <div class="flex-btn">
                        <el-button type="info" size="small" style="width:260px;">智能填报</el-button>
                    </div>
                </div>
            </div> -->
            <!-- <div class="home-login2" v-if="!token">
                <el-form class="form" size="small"
          label-width="60px">
                <div class="title" style="color:#409eff;"><i class="el-icon-user-solid"></i> 用户登录</div>
                <el-form-item label="账号：">
                    <el-input v-model="formObj.username" placeholder="账号或手机号" style="width:200px;"></el-input>
                </el-form-item>
                <el-form-item label="密码：">
                    <el-input v-model="formObj.userPwd" style="width:200px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-radio-group v-model="formObj.type" v-removeHidden
                    style="width:200px;display:flex;justify-content:space-between;">
                            <el-radio :label="1">文化生</el-radio>
                            <el-radio :label="2">艺术生</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div class="msg">
                    <i class="el-icon-warning" v-if="msg"></i> {{ msg }}
                </div>
                <el-button type="primary" @click="submitLogin('ruleForm')" @keyup.enter="keyUpEnter"
                    :disabled="loginDisabled">{{loginBtnTxt}}</el-button
                >
                <el-button type="warning" style="margin-top:20px;" @click="$router.push('/regist')"
                    >注册</el-button
                >
            <div class="forgetPwd">
                    <span>
                        <el-checkbox v-model="rember">记住我!</el-checkbox>
                    </span>
                <span
                    ><a @click="forgetPwdEvent"
                    ><i class="el-icon-lock"></i>&nbsp;忘记密码</a
                    ></span
                >
            </div>
            </el-form>
            </div> -->
            <div class="home-login3" v-if="!token">
            <div class="login-pane">
                <el-form
                :model="formObj"
                :rules="rules"
                ref="ruleForm"
                label-width="60px"
                size="small"
                class="form"
                >
                <div class="title" style="color:#409eff;"><i class="el-icon-user-solid"></i> 用户登录</div>
                        <el-form-item label="账号" prop="username">
                            <el-input v-model.trim="formObj.username" placeholder="账号或手机号" style="width:111.2%;"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="userPwd">
                            <el-input v-model.trim="formObj.userPwd" style="width:111.2%" type="password" @change="isReadStorage=false;"></el-input>
                        </el-form-item>
                <el-form-item>
                            <el-radio-group v-model="formObj.type"
                            style="width:111.2%;display:flex;justify-content:space-between;">
                                    <el-radio :label="1">
                                        <span style="color:#ebb563;font-weight:bold;font-size:15px;">文化生</span>
                                        </el-radio>
                                    <el-radio :label="2">
                                        <span style="color:#ebb563;font-weight:bold;font-size:15px;">艺术生</span>
                                        </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <div class="msg">
                            <i class="el-icon-warning" v-if="msg"></i> {{ msg }}
                        </div>
                        <el-button type="primary" @click="submitLogin('ruleForm')" style="margin-left: 10px;"
                            :disabled="loginDisabled">{{loginBtnTxt}}</el-button
                        >
                        <el-button type="warning" style="margin-top:20px;" @click="$router.push('/main/chooseRegisterType')"
                            >注册</el-button
                        >
                    <div class="forgetPwd">
                            <span>
                                <el-checkbox v-model="rember">记住我!</el-checkbox>
                            </span>
                        <span
                            ><a @click="forgetPwdEvent"
                            ><i class="el-icon-lock"></i>&nbsp;忘记密码</a
                            ></span
                        >
                    </div>
                </el-form>
            </div>
            </div>
            <div class="inner-nav">
                <div class="inner-nav-title">
                    <!-- 16 -->
                    <div class="inner-nav-font">{{year2}}+年研发经验</div>
                    <div class="vertical-line">|</div>
                    <div class="inner-nav-font">1000000+数据汇聚</div>
                    <div class="vertical-line">|</div>
                    <div class="inner-nav-font">较早使用等效分分析法</div>
                    <div class="vertical-line">|</div>
                    <div class="inner-nav-font">背靠GFKD技术团队</div>
                </div>
                <div class="inner-nav-content">
                    <div class="content-a" @click="clickToZypg">
                        <a style="color: #333;">
                            <img src="../assets/newWhsImg/B1.png" style="width:66px;height:66px;border-radius: 8px;"/>
                            <div class="content-a-inner">志愿评估(文化生)</div>
                        </a>
                    </div>
                    <div class="content-a" @click="clickToYxtj">
                        <a style="color: #333;">
                            <img src="../assets/newWhsImg/Y2.png" style="width:66px;height:66px;border-radius: 8px;"/>
                            <div class="content-a-inner">志愿推荐</div>
                        </a>
                    </div>
                    <div class="content-a" @click="clickToYxcx">
                        <a style="color: #333;">
                            <img src="../assets/newWhsImg/Y3.png" style="width:66px;height:66px;border-radius: 8px;"/>
                            <div class="content-a-inner">院校查询</div>
                        </a>
                    </div>
                    <div class="content-a" @click="clickToZycx">
                        <a style="color: #333;">
                            <img src="../assets/newWhsImg/Y4.png" style="width:66px;height:66px;border-radius: 8px;"/>
                            <div class="content-a-inner">专业查询</div>
                        </a>
                    </div>
                    <div class="content-a" @click="clickToZxgm">
                        <a style="color: #333;">
                            <img src="../assets/newWhsImg/Y6.png" style="width:66px;height:66px;border-radius: 8px;"/>
                            <div class="content-a-inner">在线购买</div>
                        </a>
                    </div>
                    <div class="content-a" @click="clickToSjcx">
                        <a style="color: #333;">
                            <img src="../assets/newWhsImg/Y7.png" style="width:66px;height:66px;border-radius: 8px;"/>
                            <div class="content-a-inner">数据查询</div>
                        </a>
                    </div>
                    <div class="content-a" @click="clickToDySx">
                        <a style="color: #333;">
                            <img src="../assets/newWhsImg/B5.png" style="width:66px;height:66px;border-radius: 8px;"/>
                            <div class="content-a-inner">多元升学</div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="bottom-div">
                <div class="product-superiority-div">
                    <div class="title">产品优势</div>
                    <div class="content-out">
                        <div class="content-div">
                            <div class="content-inner">
                                <div class="content-title">数据的加工厂</div>
                                <p class="content-font">金榜志愿通系统里的数据均来自于网络上各种公开平台，借助等效分分析方法和科学的数学模型，
                                    运用大数据分析手段，多年来，金榜志愿通团队一直对这些数据进行研究和深加工，只为给湖南省的高考生提供一个省时、省力、省心、省钱的高考志愿填报软件工具。
                                </p>
                            </div>
                            <div class="content-inner" style="margin-left:10px;background-color:#ffdeb5;">
                                <div class="content-title">等效分分析法</div>
                                <p class="content-font">
                                    金榜志愿通系统基于历年高考招生录取数据，借助等效分分析方法和科学的数学模型，
                                    运用大数据分析手段，不仅能根据各种底层逻辑分析稳中有降的各个院校专业组投档线，根据考生情况进行个性化志愿推荐，
                                    还能提供历年院校专业组录取信息，院校详细信息和学科专业信息等数据资料。</p>
                            </div>
                        </div>
                        <div class="content-div">
                            <div class="content-inner" style="background-color:#ffdeb5;">
                                <div class="content-title">大数据研究</div>
                                <p class="content-font">公司核心技术骨干来自GFKD大数据研究团队，
                                    曾获得发明专利，JD科技进步一、二、三等奖多项，以承接某某单位科研课题为契机，
                                    自2008年湖南省实行平行志愿录取规则以来，金榜志愿通团队心系广大考生和家长，以人为本，紧扣最新录取招生政策，凭精湛的技术和满腔的热情，服务了一届届考生，彰显了团队的担当与责任。
                                我们将继续秉持精益求精理念，齐众心、汇众力、聚众智，踔厉奋发、勇毅前行。</p>
                            </div>
                            <div class="content-inner" style="margin-left:10px;">
                                <div class="content-title">{{year3}}届稳定服务</div>
                                <p class="content-font">“金榜题名高考志愿填报辅助决策系统”化身为最亮的星星，与高中学生、高考考生和学生家长有了最美的相遇。照亮广大高考生与家长一路驶向成功彼岸。为考生合理填报高考志愿提供了全方位多角度的参考依据，提高了志愿填报的合理性和科学性，
                                    是广大考生高考志愿填报的利器。截至 {{ prevYear }} 年，已经平稳服务了湖南纯文化考生{{year4}}届，湖南省艺术类考生{{year5}}届。
                                    接下来，让我们继续抖擞精神，步履铿锵，追光而行。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="use-the-process-div">
                    <div class="title">使用流程</div>
                    <div class="content-out">
                        <div class="content-font">输入成绩和选科等信息</div>
                        <i class="el-icon-caret-right" style="display:inline-block;font-size: 128.6%;margin: 0 1.08%;"></i>
                        <div class="content-font">选择纬度</div>
                        <i class="el-icon-caret-right" style="display:inline-block;font-size: 128.6%;margin: 0 1.08%;"></i>
                        <div class="content-font">筛选结果</div>
                        <i class="el-icon-caret-right" style="display:inline-block;font-size: 128.6%;margin: 0 1.08%;"></i>
                        <div class="content-font">生成高考志愿方案表</div>
                    </div>
                </div>
            </div>
        </div>
        <forget-pwd
      :dialogFormVisible="isShow"
      v-if="isShow"
      @closedialog="closedialog"
    />
    </div>
</template>
<script>
import {mapState,mapActions} from 'vuex';
import { pwdLogin } from '../api';
import {loginAfterReload,getCurrentOpenPageList} from '../common/loginout';
import bcryptjs from "bcryptjs";
import forgetPwd from "../components/ysh/ForgetPwd";
import CryptoJs from "crypto-js"
import {encrypt} from "../common/AEC";
export default {
    data(){
        return{
            carousels:[
                // {itemUrl:require("../assets/newWhsImg/主页图片1-tuya.png")},
                // {itemUrl:require("../assets/newWhsImg/主页图片2-tuya.png")},
                // {itemUrl:require("../assets/newWhsImg/主页图片3-tuya.png")},
                // {itemUrl:require("../assets/newWhsImg/主页图片4-tuya.png")}
            ],
            carouselsImg:"",
            imageUrl:"",
            isShow:false,
            sssf:43,
            wlType:"info",
            lsType:"info",
            hxType:"info",
            swType:"info",
            zzType:"info",
            dlType:"info",
            zxkmNums:0,
            score:"",
            formObj:{
                username:'',
                userPwd:'',
                type:1
            },
            msg:'',
            loginDisabled:false,
            loginBtnTxt:'登录',
            rember:false,
            rules:{
                username:[
                    {required:true,message:'请输入注册时填写的手机号',trigger:'blur'}
                ],
                userPwd:[
                    {required:true,message:'请输入注册时设置的密码',trigger:'blur'}
                ]
            },
            prevYear:"",
            year1:"",
            year2:"",
            year3:"",
            year4:"",
            year5:"",
            isReadStorage:false,
            isMd5:false
        };
    },
    methods:{
        ...mapActions(["saveUserInfo"]),
        forgetPwdEvent(){
            // const type = this.formObj.type;
            // if(type===1){
            //     this.$router.push("/main/findPwd");
            // }else{
            //     this.isShow=!this.isShow;
            // }
                this.$router.push("/main/findPwd");
        },
        submitLogin(refForm){
            const yfLoad=this.yfLoadElement;
            if(!yfLoad){
                this.$message({message:"页面还没加载完，请稍等一会儿"});
                return;
            }
            const openPageList=getCurrentOpenPageList();
            if(openPageList.length===0){  
                this.$message({message:"页面还没加载完，请稍等一会儿"});
                return;
            }
            this.$refs[refForm].validate(async (validate) => {
                if(validate){
                    const type=this.formObj.type;
                    if(type===1){
                        const username=this.formObj.username;
                        // const salt = bcryptjs.genSaltSync(10);
                        // const password = bcryptjs.hashSync(this.formObj.userPwd, salt);
                        const password=this.isReadStorage&&this.isMd5?this.formObj.userPwd:this.$md5(this.formObj.userPwd);
                        const bjmPwd=this.formObj.userPwd;
                        // const password=this.ruleForm.password;
                        const sf=43;
                        this.loginBtnTxt="登录中...";
                        this.loginDisabled=true;
                        const res=await this.$http.postHttp("/login/login",{
                            username,password,sf,type
                        });
                        if(res.data.code===200){
                            this.isLogin=true;
                            const token=res.data.obj.token;
                            const userInfo=res.data.obj.userInfo;
                            // sessionStorage.setItem("token",token);
                            this.$store.dispatch("saveToken",token);
                            this.$store.dispatch("saveUserInfo",userInfo);
                            this.$store.commit('initIsUpdateToken');
                            const rember=this.rember;
                            if(rember){
                                this.$store.dispatch('saveUserName',username);
                                this.$store.dispatch('saveUserPwd',password);
                                this.$store.commit('saveIsMd5',{isMd5:true});
                            }else{
                                this.$store.dispatch('initUserName');
                                this.$store.dispatch('initUserPwd');
                                this.$store.commit('saveIsMd5',{isMd5:false});
                            }
                            this.$store.dispatch("setUserType",{type});
                            this.msg='';
                            loginAfterReload();
                        }else if(res.status===409||res.status===410||res.status===411){
                            this.$message({message:'您的账号在其他地点登陆了！',showClose:true,type:'warning'});
                        }else{
                            // 登陆失败
                            if(res.data.message){
                                this.msg = `${res.data.message}`;
                            }else{
                                this.msg="账号或密码错误";
                            }
                        }
                        this.loginBtnTxt="登录";
                        this.loginDisabled=false;
                    }else{
                        console.log("艺术生登录");
                        // const username=this.formObj.username;
                        // const salt = bcryptjs.genSaltSync(10);
                        // const password=bcryptjs.hashSync(this.formObj.userPwd,salt);
                        // const password=this.formObj.userPwd;
                        // const password=this.$md5(this.formObj.password);
                        // const result = await pwdLogin(
                        //     username,password
                        // );
                        // if (result.code === 200) {
                        //     //登陆成功
                        //     let userInfos = result.data;
                        //     this.saveUserInfo(userInfos);
                        //     this._totalScore(
                        //     userInfos.zylb,
                        //     userInfos.wscore,
                        //     userInfos.zscore
                        //     );
                        //     this.$store.dispatch("RestSchoolData");
                        // } else {
                        //     //登陆失败
                        //     this.userInfos = result.data;
                        //     this.msg = `${result.msg}`;
                        // }
                        const username=this.formObj.username;
                        let str="";
                        for(let i=1;i<17;i++){
                            const sjs=Math.floor(Math.random()*16).toString(16);
                            str+=sjs;
                        }
                        // const password =encrypt(this.formObj.userPwd);
                        // const salt = bcryptjs.genSaltSync(10);
                        // const password = bcryptjs.hashSync(this.formObj.userPwd, salt);
                        const salt="cvdf-yyds*123.cv987@";
                        const password=this.isReadStorage&&this.isMd5?this.formObj.userPwd:this.$md5(this.formObj.userPwd);
                        const bjmPwd=this.formObj.userPwd;
                        // const password=this.ruleForm.password;
                        const sf=43;
                        this.loginBtnTxt="登录中...";
                        this.loginDisabled=true;
                        const res=await this.$http.postHttp("/login/login",{username,password,sf,type});
                        console.log(res);
                        if(res.data.code===200){
                            this.isLogin=true;
                            const token=res.data.obj.token;
                            const userInfo=res.data.obj.userInfo;
                            // sessionStorage.setItem("token",token);
                            this.$store.dispatch("saveToken",token);
                            this.$store.dispatch("saveUserInfo",userInfo);
                            this.$store.commit('initIsUpdateToken');
                            const rember=this.rember;
                            if(rember){
                                this.$store.dispatch('saveUserName',username);
                                this.$store.dispatch('saveUserPwd',password);
                                this.$store.commit('saveIsMd5',{isMd5:true});
                            }else{
                                this.$store.dispatch('initUserName');
                                this.$store.dispatch('initUserPwd');
                                this.$store.commit('saveIsMd5',{isMd5:false});
                            }
                            this.$store.dispatch("setUserType",{type});
                            this.msg='';
                            loginAfterReload();
                        }else if(res.status===409||res.status===410||res.status===411){
                            this.$message({message:'您的账号在其他地点登陆了！',showClose:true,type:'warning'});
                        }else{
                            // 登陆失败
                            if(res.data.message){
                                this.msg = `${res.data.message}`;
                            }else{
                                this.msg="账号或密码错误";
                            }
                        }
                        this.loginBtnTxt="登录";
                        this.loginDisabled=false;
                    }
                }else{
                    return false;
                }
            });
        },
        closedialog(dialogStatus) {
            this.isShow = dialogStatus;
        },
            //动态计算当年综合分
    _totalScore(lb, wscore, zscore) {
      //编导，播音与主持，摄影摄像
      let totalScore = 0;
      // if (lb == "编导类" || lb == "播音与主持艺术类" || lb == "摄影摄像类") {
      //   totalScore = Number(wscore) + Number(zscore);
      //   this.$store.dispatch("saveTatalScore", totalScore);
      // } else {
      //   totalScore = (wscore * 0.3 + zscore * 0.7).toFixed(1);
      //   this.$store.dispatch("saveTatalScore", totalScore);
      // }
      if (lb == "播音与主持类") {
        totalScore = Number(wscore) + Number(zscore);
        this.$store.dispatch("saveTatalScore", totalScore);
      } else {
        totalScore = (wscore * 0.3 + zscore * 0.7).toFixed(1);
        this.$store.dispatch("saveTatalScore", totalScore);
      }
    },
        changeSxkm(sxkm){
            if(sxkm===1){
                this.lsType="primary";
                this.wlType="info";
            }else{
                this.lsType="info";
                this.wlType="primary";
            }
        },
        changeZxkm(zxkmName){
            if(zxkmName==="化学"){
                if(this.hxType==="primary"){
                    this.hxType="info";
                    this.zxkmNums--;
                }else{
                    const zxkmNums=this.zxkmNums;
                    if(zxkmNums===2){
                            this.$message({message:"再选科目最多选两个",showClose:true,type:'warning'});
                            return;
                    }
                    this.hxType="primary";
                    this.zxkmNums++;
                }
            }else if(zxkmName==="生物"){
                if(this.swType==="primary"){
                    this.swType="info";
                    this.zxkmNums--;
                }else{
                    const zxkmNums=this.zxkmNums;
                    if(zxkmNums===2){
                            this.$message({message:"再选科目最多选两个",showClose:true,type:'warning'});
                            return;
                    }
                    this.swType="primary";
                    this.zxkmNums++;
                }
            }else if(zxkmName==="政治"){
                if(this.zzType==="primary"){
                    this.zzType="info";
                    this.zxkmNums--;
                }else{
                    const zxkmNums=this.zxkmNums;
                    if(zxkmNums===2){
                            this.$message({message:"再选科目最多选两个",showClose:true,type:'warning'});
                            return;
                    }
                    this.zzType="primary";
                    this.zxkmNums++;
                }
            }else{
                if(this.dlType==="primary"){
                    this.dlType="info";
                    this.zxkmNums--;
                }else{
                    const zxkmNums=this.zxkmNums;
                    if(zxkmNums===2){
                            this.$message({message:"再选科目最多选两个",showClose:true,type:'warning'});
                            return;
                    }
                    this.dlType="primary";
                    this.zxkmNums++;
                }
            }
        },
        async clickToZypg(){
            // this.$router.push("");
            // const obj0={};
            // obj0.role=99;
            // obj0.type='zypg';
            // const res0=await this.$http.postHttp('/enumRole/getFlag',obj0);
            // if(res0.data.code===200){
            //     if(res0.data.obj.length>0){
            //         const flag=res0.data.obj[0].flag;
            //         if(flag!==1){
            //             this.$message({message:'此功能仅在高考志愿填报期间开放',showClose:true});
            //             this.dialogProVisble=false;
            //             return;
            //         }else{
            //             const aEl=document.createElement("a");
            //             aEl.href="http://zypg.zy1dt.com";
            //             aEl.click();
            //         }
            //     }
            // }
            // this.$message({message:'此功能仅在高考志愿填报期间开放',showClose:true});
            const type=this.userType;
            if(type===1){
                this.$router.push("/main/zypg");
            }
        },
        clickToYxtj(){
            const type = this.userType;
            if(type===1){
                this.$router.push("/main/schoolRecommend");
            }else {
                this.$router.push("/main/yshSchoolRecommend");
            }
        },
        clickToYxcx(){
            const type = this.userType;
            if(type===1){
                this.$router.push("/main/schoolfinder");
            }else{
                this.$router.push("/main/yshSchoolFinder");
            }
        },
        clickToZycx(){
            const type = this.userType;
            if(type===1){
                this.$router.push("/main/majorquery");
            }else{
                this.$router.push("/main/yshMajorQuery");
            }
        },
        clickToDySx(){
            const type=this.userType;
            if(type===1){
                this.$router.push("/main/DuoYuanShengXue");
            }
        },
        clickToZxgm(){
            this.$router.push("/main/buyindex");
        },
        clickToSjcx(){
            const type = this.userType;
            if(type===1){
                this.$router.push("/main/datahome");
            }else{  
                this.$router.push("/main/yshDataHome");
            }
        },
        getSeaSonImg(){
            const month=new Date().getMonth()+1;
            const arr=[];
            if(month>=1&&month<=3){
                // arr.push({itemUrl:require("../assets/newWhsImg/主页图片1-tuya.png")});
                this.carouselsImg=require("../assets/newWhsImg/主页图片1-tuya.png");
            }else if(month>=4&&month<=6){
                // arr.push({itemUrl:require("../assets/newWhsImg/主页图片2-tuya.png")});
                this.carouselsImg=require("../assets/newWhsImg/主页图片2-tuya.png");
            }else if(month>=7&&month<=9){
                // arr.push({itemUrl:require("../assets/newWhsImg/主页图片3-tuya.png")});
                this.carouselsImg=require("../assets/newWhsImg/主页图片3-tuya.png");
            }else if(month>=10&&month<=12){
                // arr.push({itemUrl:require("../assets/newWhsImg/主页图片4-tuya.png")});
                this.carouselsImg=require("../assets/newWhsImg/主页图片4-tuya.png")
            }
        }
    },
    computed:{
        ...mapState(["token","userInfo","userType","yfLoadElement"])
    },
    components:{
        forgetPwd
    },
    mounted(){
        const year=new Date().getFullYear();
        const month=new Date().getMonth()+1;
        let cha=year-2008+1;
        if(month>=8){
            cha+=1;
        }else{
            cha=year-2008+1;
        }
        this.year1=cha+"";
        const cha2=year-2008+1;
        this.year2=cha2+"";
        // 从当年届开始算
        const cha3=(year-2012+1);
        this.year3=cha3+"";
        // 从当年届开始算
        const cha4=(year-2012+1);
        this.year4=cha4+"";
        const cha5=(year-2018);
        this.year5=cha5+"";
        const userStr=localStorage.getItem("user");
        if(userStr){
            const user=JSON.parse(userStr);
            if(user.userName&&user.userPwd){
                this.formObj.username=user.userName;
                this.formObj.userPwd=user.userPwd;
                this.rember=true;
                this.isReadStorage=true;
                this.isMd5=user.isMd5;
            }
        }

        if(month>=8){
            this.prevYear=year+"";
            this.year5=(year-2018)+1;
            this.year3=(year-2012+1)+1;
            this.year4=(year-2012+1)+1;
        }else{
            this.prevYear=(year-1)+"";
            this.year5=(year-2018);
            this.year3=(year-2012+1);
            this.year4=(year-2012+1);
        }
        // this.prevYear=(year-1)+"";
        // this.prevYear=(year)+"";
        this.getSeaSonImg();
    }
};
</script>
<style scoped lang="less">
.home-container{
                min-width:1200px;
                position:relative;
                background-color:#f5f5f5;
                .top-img-font {
    position: absolute;
    // top: 136px;
    // left: 168px;
    // top: 24px;
    // left: 100px;
    top:5%;
    left: 7%;
    .font1 {
      color: white;
      font-size: 24px;
      font-weight: bold;
      // font-style: italic;
    }
    .font2 {
      color: white;
      font-size: 18px;
    }
    .font3 {
      color: white;
      font-size: 18px;
    }
  }
  .top-img-font2 {
    position: absolute;
    display: flex;
    font-size: 46px;
    color: white;
    // top: 260px;
    // left: 100px;
    top: 57%;
    left: 7%;
    .font1 {
    }
    .font2 {
      margin-left: 40px;
    }
  }
  .top-img-font3 {
    position: absolute;
    display: flex;
    color: white;
    font-size: 35px;
    // top: 330px;
    // left: 110px;
    top: 72%;
    left: 7.8%;
    font-family: 华文行楷;
    .font2 {
      margin-left: 35px;
    }
    .font3 {
      margin-left: 35px;
    }
    .font4 {
      margin-left: 35px;
    }
  }
    .home-login{
                position:absolute;
                left:50%;
                top:0;
                width:1200px;
                height:300px;
                margin-left:-600px;
                z-index:888;
                background-color:transparent;
                .login-pane {
                position: absolute;
                right: 0;
                // top: 20px;
                // top:ceil(10vh);
                top: 77px;
                width: 300px;
                background-color: #fff;
                border-radius: 5px;
                .login-top{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px;
                }
                .flex-div{
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding: 0 10px;
                    padding-bottom: 10px;
                }
                .flex-btn{
                    display: flex;
                    justify-content: center;
                    padding-bottom: 10px;
                }
            }
    }
    .product-superiority-div{
        // width: 930px;
        width: 65.2%;
        // margin:0 auto;
        margin: 0 17.5%;
        // margin: 0 17%;
        // margin-top: 130px;
        // padding-top: 130px;
        padding-top: 10%;
        .title{
            font-weight: bold;
            font-size: 25px;
            color: black;
            // margin: 20px 0;
            margin: 1.94% 0;
        }
        .content-out{
            .content-div{
                display: flex;
                .content-inner{
                    // background-color: #EBEFF2;
                    background-color: #dbf3ff;
                    // width: 460px;
                    width: 50%;
                    // padding: 10px;
                    padding: 0.97%;
                    // margin-bottom: 10px;
                    margin-bottom: 0.97%;
                    .content-title{
                        color: black;
                        font-weight: bold;
                        font-size: 18px;
                        // padding: 10px;
                        padding: 0.97%;
                    }
                    .content-font{
                        // width: 364px;
                        // padding: 10px;
                        width: 84%;
                        padding: 0.97%;
                    }
                }
            }
        }
    }
    .use-the-process-div{
        // width: 930px;
        width: 65.2%;
        // margin:0 auto;
        margin: 0 17.5%;
        padding-bottom: 50px;
        .title{
            font-weight: bold;
            font-size: 25px;
            color: black;
            // margin: 20px 0;
            margin: 1.94% 0;
        }
        .content-out{
            .content-font{
                // width: 184px;
                width: 19.78%;
                // width: 20.4%;
                display: inline-block;
                text-align: center;
                background-color: #EBEFF2;
                // padding: 10px;
                // padding: 1.07%;
                padding: 0.8%;
                color: black;
                font-weight: bold;
                margin-top: 1.07%;
            }
        }
    }
    .inner-nav{
        // width: 930px;
        width: 65.2%;
        margin:0 auto;
        // border: 1px solid white;
        border-radius: 5px;
        // background-color: white;
        position: absolute;
        // top: 402px;
        top: 31%;
        // left: 246px;
        left: 17.5%;
        background-image: url(../assets/newWhsImg/按钮底图.png);
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        background-size: 100% 100%;
        .inner-nav-title{
            display: flex;
            justify-content: center;
            // width: 890px;
            width: 95.66%;
            margin: 0 auto;
            margin-top: 10px;
            margin-bottom: 30px;
            .vertical-line{
                margin:0 20px;
            }
            .inner-nav-font{
                color: black;
            }
        }
        .inner-nav-content{
            display: flex;
            justify-content: center;
            // width: 890px;
            width: 95.66%;
            margin: 20px auto;
            margin-top: 0;
            .content-a{
                margin: 0 20px;
                a{
                    text-decoration: none;
                }
                a:hover{
                    // color: blue;
                        color: #0cf;
                        text-decoration: none;
                        // font-size: 16px;
                }
                .content-a-inner{
                    width: 66px;
                    // width: 60.6%;
                    text-align: center;
                    font-weight: bold;
                    margin-top: 10px;
                }
            }
        }
    }
    .home-login2{
        position:absolute;
                left:50%;
                top:0;
                right: 0;
                width:1200px;
                height:300px;
                // margin-left:-600px;
                z-index:888;
                background-color:transparent;
    .form{
            width: 260px;
            height: 320px;
            text-align: right;
            background: white;
            padding: 10px;
            .el-button{
                width: 95%;
                height: 35px;
                font-size: 16px;
                // margin: 0 0 0 20px;
            }
            .title{
                        margin: 15px 0;
                        font-size: 16px;
                        font-weight: bolder;
                        text-align: center;
                        color: #409eff;
            }
    }
    .forgetPwd{
            width: 95%;
            padding: 11px;
            margin: 0 auto;
            font-size: 14px;
            display: flex;
            justify-content: space-between;
            align-items: center;
    }
    }
    .home-login3{
        position:absolute;
                left:8%;
                // left:50%;
                top:0;
                // width:1200px;
                width: 84.1%;
                // height:400px;
                height: 30.7%;
                // margin-left:-600px;
                z-index:888;
                background-color:transparent;
                .login-pane{
                    position: absolute;
                    right: 0;
                    // top: 20px;
                    // top:ceil(10vh);
                    // top: 77px;
                    // top:16px;
                    top:4.6%;
                    // width: 300px;
                    width: 25%;
                    background-color: #fff;
                    border-radius: 5px;
                    .form{
                        // width: 260px;
                        // height: 350px;
                        width: 80%;
                        height: 36%;
                        text-align: right;
                        background: white;
                        // padding: 10px;
                        padding: 3.4%;
                        .title{
                            margin: 15px 0;
                            font-size: 16px;
                            font-weight: bolder;
                            text-align: center;
                            color: #409eff;
                        }
                        .forgetPwd{
                            // width: 103%;
                            width: 112%;
                            padding: 11px;
                            margin: 0 auto;
                            font-size: 14px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            a{
                                color: #666;
                            }
                        }
                        .msg{
                            height: 30px;
                            line-height: 30px;
                            text-align: center;
                            font-size: 14px;
                            color: #f56c6c;
                        }
                        .el-button{
                            width: 103%;
                            height: 35px;
                            font-size: 16px;
                            // margin: 0 0 0 20px;
                        }
                    }
                }
    }
    .bottom-div{
        background-image: url(../assets/newWhsImg/背景底图.png);
    }
}
.login-pane form{
	box-sizing: content-box !important;
}
.content-font{
	box-sizing: content-box !important;
}
</style>
